import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ClienteMacrosegRepository } from 'src/app/domain/service/cliente-macroseg/cliente-macroseg-repository';
import { ClienteMacroseg } from '@model/cliente-macroseg/cliente-macroseg';

/**
 * Adaptador HTTP: HttpClienteMacrosegRepository
 *
 * Implementa el puerto ClienteMacrosegRepository para comunicación HTTP con backend.
 * Realiza llamadas REST al backend Spring Boot (ClienteMacrosegController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto ClienteMacrosegRepository del dominio
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 *
 * @author Sura - Migración GWT a Spring Boot
 */
@Injectable({ providedIn: 'root' })
export class HttpClienteMacrosegRepository implements ClienteMacrosegRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/macrosegmentaciones`;

  async obtenerMacrosegmentaciones(nmconsecutivoCliente: number): Promise<ClienteMacroseg[]> {
    const params = new HttpParams().set('nmconsecutivoCliente', nmconsecutivoCliente.toString());
    return firstValueFrom(
      this.http.get<ClienteMacroseg[]>(this.baseUrl, { params })
    );
  }
}
